<script setup lang="ts">
import { useDynDNSStore } from '@kidzonet/dashboard-dyn-dns-store'

import AddForm from './Form.vue'
import Host from './Host.vue'

const store = useDynDNSStore()
store.fetchHostsList()
</script>

<template>
    <div>
        <v-progress-linear
            v-if="store.loading"
            indeterminate
            color="primary"
            size="100"
            width="10"
        />
        <AddForm v-else-if="store.canUserAddHosts" />
        <Host v-else-if="store.hosts.length > 0" />
    </div>
</template>
